<app-side-nav></app-side-nav>
<div
  class="createQuestionBody"
  [@sideNavContentTrigger]="sidenav.getIsOpen() ? 'open' : 'closed'"
>
  <app-questions-form *ngIf="formData" [data]="formData"></app-questions-form>
</div>
